import { authenticatedInstance } from '../index/index.service';
import { defaultStreamUrl, subscribeStream } from '../sse-subscribe/sse-subscribe.util';

// Summary: Wire-format for the picker employee SSE stream.
// Details: docs/function-library/web/services.md#employees-events-service
export type EmployeesEvent =
  | { type: 'employee.upserted'; employee: unknown }
  | { type: 'employee.deactivated'; employeeId: number };

const EMPLOYEES_EVENT_TYPES: ReadonlyArray<EmployeesEvent['type']> = [
  'employee.upserted',
  'employee.deactivated',
];

// Summary: Mints a single-use SSE ticket via authenticated POST for the PRE-employee-login POS picker.
// Details: docs/function-library/web/services.md#employees-events-service
async function mintPickerEmployeesStreamTicket(tenantId: string): Promise<string> {
  const response = await authenticatedInstance.post<{ ticket: string; expiresAt: number }>(
    `/employees/tenant/${tenantId}/picker-stream-ticket`,
    {},
  );
  if (!response.data?.ticket) {
    throw new Error('Picker employees stream ticket missing in response');
  }
  return response.data.ticket;
}

// Summary: Opens a tenant-scoped SSE stream for employee lifecycle events on the POS pre-login picker (no employee session yet).
// Details: docs/function-library/web/services.md#employees-events-service
export function subscribePickerEmployeesEvents(
  tenantId: string,
  onEvent: (event: EmployeesEvent) => void,
  onError?: () => void,
): () => void {
  return subscribeStream<EmployeesEvent>({
    mintTicket: () => mintPickerEmployeesStreamTicket(tenantId),
    buildStreamUrl: (ticket, lastEventId) =>
      defaultStreamUrl(`/employees/tenant/${encodeURIComponent(tenantId)}/picker-stream`, ticket, lastEventId),
    parseEvent: (payload) => {
      const candidate = payload as EmployeesEvent | undefined;
      if (
        candidate &&
        typeof candidate.type === 'string' &&
        EMPLOYEES_EVENT_TYPES.includes(candidate.type)
      ) {
        return candidate;
      }
      return null;
    },
    onEvent,
    onError,
  });
}



